import React from 'react';

import Chip from '@mui/material/Chip';
import { useAtomValue } from 'jotai';
import { Link } from 'react-router-dom';

import { firstFlightDrawIdAtomFamily } from 'atoms/events';
import { getEventRoute } from 'config/router/utils';
import { type EventInterface } from 'typedefs/store/tmxTypes';

import { useStyles } from './styles';

interface EventChipContainerProps {
  event: EventInterface;
}

export const EventChipContainer: React.FC<React.PropsWithChildren<EventChipContainerProps>> = React.memo(
  ({ event }) => {
    const firstFlightDrawId = useAtomValue(firstFlightDrawIdAtomFamily(event.eventId));
    return (
      <EventChip
        href={event.tournamentId ? getEventRoute(event.tournamentId, event.eventId, firstFlightDrawId) : undefined}
        name={event.eventName}
      />
    );
  },
);

interface EventChipProps {
  name: string;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
}

export const EventChip: React.FC<React.PropsWithChildren<EventChipProps>> = React.memo(({ name, onClick, href }) => {
  const { classes } = useStyles();
  return (
    <Chip
      className={classes.eventChip}
      label={name}
      size="small"
      {...(onClick && { onClick })}
      {...(href && {
        to: href,
        component: Link,
      })}
      {...((href || onClick) && { clickable: true })}
    />
  );
});

export default EventChipContainer;
